
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { prefetchContextualRoutes, prefetchCriticalRoutes } from '@/utils/routing/routePrefetcher';
import { initializeRouteRegistry } from '@/utils/routing/routePreloadRegistry';

/**
 * Silent component that prefetches routes based on the current location
 * This helps improve perceived performance by loading routes before they're needed
 */
const RoutePrefetcher: React.FC = () => {
  const location = useLocation();
  
  // Initialize route registry on mount
  useEffect(() => {
    initializeRouteRegistry();
    prefetchCriticalRoutes();
    
    // Log initialization
    console.log('📝 Route prefetching initialized');
  }, []);
  
  // Prefetch contextual routes whenever the location changes
  useEffect(() => {
    prefetchContextualRoutes(location.pathname);
  }, [location.pathname]);
  
  // This component doesn't render anything
  return null;
};

export default RoutePrefetcher;
